import { MessageChatProps, TemplateProps } from '../../../../../context/ChatWhatsAppContext'
import { BsFileTextFill } from "react-icons/bs";
import { MdDownload } from "react-icons/md";
import { IoOpenOutline } from "react-icons/io5";

interface UserMessageProps extends MessageChatProps {
  template?: TemplateProps,
  type: string
}

export const UserMessage = ({ text, time, template, type, linkImage, documentName }: UserMessageProps) => {
  const renderComponent = (component: any) => {
    switch (component.type) {
      case 'body':
        return <p className="text-xs">{component.parameters[0].text} </p>;
      default:
        return null;
    }
    // <video controls src="video/demo.mp4"></video>
    // <audio src="audio.ogg" controls> </audio>
  };

  function previewButton() {
    window.open(linkImage, '_blank')
  }

  function renderMessage() {
    if (type === 'template' && template) {
      return template.components.map(component => renderComponent(component))
    } else if (type === "image") {
      return <img src={linkImage} alt="" className='' />
    } else if (type === 'document') {
      return (
        <div className='flex items-center gap-2 text-xs'>
          <BsFileTextFill size={22} className="fill-white" />
          <p className='text-center'>{documentName}</p>
          <button onClick={previewButton}>
            <IoOpenOutline size={22} className="fill-white" />
          </button>
        </div>
      )
    }
    else {
      return <p className="text-xs">{text} </p>
    }
  }


  return (
    <div className="m-2 ml-auto mt-0 flex w-full max-w-xs justify-end space-x-3">
      <div className="text-end ">
        <div className=" rounded-l-lg rounded-br-lg bg-blue-600 p-3 text-start  text-white">

          {/* {type === 'template' && template ? template.components.map(component => renderComponent(component)) : <p className="text-xs">{text} </p>} */}
          {renderMessage()}

        </div>
        <span className="pr-2 text-[10px] leading-none text-gray-500">
          {time}
        </span>
      </div>
    </div>
  );
};
